import { useContext } from 'react';

import { createPermissionChecker } from '@uptime/shared/utils/permissions';

import { PermissionsContext } from '../../providers/PermissionsProvider';

const PARTNER_FEATURE = 'partner';

const usePermissions = () => {
  const { permissions, setPermissions, hasPermissionsLoaded, setHasPermissionsLoaded } =
    useContext(PermissionsContext);

  // Dummy permission, will be replaced when there are some features
  const partnerPermission = createPermissionChecker(permissions)(PARTNER_FEATURE);

  return {
    setPermissions,
    hasPermissionsLoaded,
    setHasPermissionsLoaded,
    partnerPermission,
  };
};

export default usePermissions;
